import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import dictionary from 'config/dictionary.json';
import styles from './error.module.scss';
import errorImage from 'assets/img/nohugggs.png';

const BaseError = (props) => {
  const { className, errorMessage, render } = props;

  return (
    <div className={classnames('container', styles.container, className)}>
      {render && render.constructor === Function ? (
        render()
      ) : (
        <>
          <img
            src={errorImage}
            alt="icon denoting no items found"
            className={styles.image}
          />

          <p className={styles.summary} data-test-id="error-message-default">
            {errorMessage || dictionary.error.default}
          </p>
        </>
      )}
    </div>
  );
};

BaseError.propTypes = {
  className: PropTypes.string,
  errorDetails: PropTypes.object,
  errorMessage: PropTypes.string,
  render: PropTypes.func,
};

export default BaseError;
